import React from "react";
import { Slider } from "../../components/Slider";
import { AuthData } from "../../types/AuthData";

interface props {
  data: AuthData;
  volumeUpdater: number;
}

const AudioSection: React.FC<props> = ({ data, volumeUpdater }) => {
  return (
    <>
      <div className="flex justify-center items-center gap-5">
        <img
          className="h-[25px]"
          src={"/ranks/" + data.rank + ".png"}
          alt={data.rank}
        ></img>
        <p className="text-white text-2xl font-['Minecraft'] font-light flex items-center justify-center text-center">
          {data.name}
        </p>
      </div>
      <img
        src={"https://mc-heads.net/avatar/" + data.uuid + "/150"}
        width={150}
        height={150}
        className="rounded-lg"
      ></img>
      <div className="w-full select-none">
        <div className="flex flex-col justify-center items-center gap-5">
          <label className="text-xl text-white">Ambient:</label>
          <Slider type="music" volumeUpdater={volumeUpdater}></Slider>
        </div>
        <div className="flex flex-col justify-center items-center gap-5">
          <label className="text-xl text-white">Effects:</label>
          <Slider type="effect" volumeUpdater={volumeUpdater}></Slider>
        </div>
      </div>
    </>
  );
};

export default AudioSection;
